<template>
  <crud-editor
    ref="editor"
    :show-delete-button="false"
    :show-save-and-next-button="false"
    :is-edit="false"
    :definition="definition"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :get-layout="layout"
    :get-route-on-save="getRouteOnSave"
  />
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { getCreateLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data() {
    return {
      layout: getCreateLayoutDefinition
    };
  },
  computed: {
    domainID() {
      return parseInt(this.$route.params.domainID);
    },
    productGroupID() {
      return this.$route.params.productGroupID;
    },
    productGroupDescription() {
      return this.$route.params.description;
    }
  },
  async created() {
    await Promise.all([this.$store.dispatch('finish/getItems'), this.$store.dispatch('finishType/getItems')]);
  },
  methods: {
    saveData(form) {
      form.domainID = this.domainID;
      form.productGroupID = this.productGroupID;
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    },
    getRouteOnSave() {
      return {
        name: 'Edit' + this.entity,
        params: {
          id: 0,
          domainID: this.domainID,
          productGroupID: this.productGroupID,
          description: this.productGroupDescription
        }
      };
    }
  }
};
</script>
